import styled from 'styled-components';

export const StyledBlurred = styled.div`
  filter: blur(1rem);
`;
